<script>
import Banner from '@/components/general/Banner'
import MemberSubmenu from '@/components/workspace/businessWorkspace/WorkspaceManagement/MemberSubmenu'
export default {
  name: 'HomepageUserMembers',
  components: { MemberSubmenu, Banner }
}
</script>
<template>
  <div class="homepage-user-members--container">
    <banner
      background-color="secondary-lightest"
      background-figure="/assets/images/workspace-banners/members.png"
      background-position="center right"
    >
      <div class="homepage-user-members--banner__wrapper">
        <h5>{{ $t('home.user.members.banner:title') }}</h5>
        <p class="body--1">{{ $t('home.user.members.banner:subtitle') }}</p>
      </div>
    </banner>
    <member-submenu/>
  </div>
</template>
<style lang="scss">
.homepage-user-members--container {
  padding-bottom: 40px;
  .homepage-user-members--banner__wrapper {
    text-align: left;
    padding: 50px 24px;
    > * {
      margin: 0;
    }
  }
  @media only screen and (max-width: 768px) {
    padding-bottom: 70px;
  }
}
</style>
